module.exports = __webpack_public_path__ + "static/media/the-most-livable-cities.70d7af34.png";